export default __webpack_public_path__ + "static/media/rfbin_1.83980667.png";